var _defs, _path, _path2, _rect, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew292({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.84,6.63l1.3-4.14h.48L6,6.63H5.5L5.11,5.37H3.68L3.31,6.63Zm1-1.7H5L4.61,3.78c-.11-.35-.19-.64-.24-.86a5.32,5.32,0,0,1-.18.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.3,13.23V9.09h1.28a2.16,2.16,0,0,1,.67.08,1,1,0,0,1,.47.4,1.41,1.41,0,0,1,.17.71,1.42,1.42,0,0,1-.28.92,1.22,1.22,0,0,1-1,.35h-.87v1.68Zm.45-2.17h.88a.83.83,0,0,0,.61-.19.73.73,0,0,0,.19-.56.83.83,0,0,0-.1-.43.49.49,0,0,0-.22-.23,1.12,1.12,0,0,0-.49-.07h-.87Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 15,
    y1: 1,
    x2: 1,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew292);
export default __webpack_public_path__ + "static/media/Symbolpack_New_292.bde4d6d305fd336d29b9145dd07dcac4.svg";
export { ForwardRef as ReactComponent };